import { render, staticRenderFns } from "./apply-recorddetails.vue?vue&type=template&id=bedda38c&scoped=true&"
import script from "./apply-recorddetails.vue?vue&type=script&lang=js&"
export * from "./apply-recorddetails.vue?vue&type=script&lang=js&"
import style0 from "./apply-recorddetails.vue?vue&type=style&index=0&id=bedda38c&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedda38c",
  null
  
)

export default component.exports